const protectionItems = [
  {
    title: "Pet mishaps",
    description: "Scratches, bites or a curious pet knocking it over",
    image: "/clients/Mecturing/Accident1.png",
  },
  {
    title: "Liquid spills",
    description: "A single, unintended spill or liquid ingress",
    image: "/clients/Mecturing/Accident2.png",
  },
  {
    title: "Drops and falls",
    description: "Unexpected drops that crack or break the unit",
    image: "/clients/Mecturing/Accident3.png",
  },
  {
    title: "Impacts and collisions",
    description: "Bumps, knocks or a sudden external force",
    image: "/clients/Mecturing/Accident4.png",
  },
];

export default function AccidentalDamageGrid() {
  return (
    <section className="tw-bg-[#0B0D10] tw-py-24">
      <div className="tw-max-w-[1120px] tw-mx-auto tw-px-6 xl:tw-px-0">
        {/* Heading */}
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-3.5 tw-text-center tw-mb-12">
          <h2 className="tw-text-3xl md:tw-text-[40px] tw-leading-[normal] tw-font-semibold tw-tracking-[-0.01em] tw-text-white">
            Accidental Damage Protection
          </h2>
          <p className="tw-max-w-[720px] tw-text-base md:tw-text-[17px] tw-leading-[27px] tw-text-[#A1A1AA]">
            Covered for the everyday accidents that happen — after delivery,
            during normal use.
          </p>
        </div>

        {/* Cards */}
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-5">
          {protectionItems.map((item) => (
            <div
              key={item.title}
              className="tw-relative tw-h-[380px] tw-rounded-[20px] tw-overflow-hidden"
            >
              <img
                src={item.image}
                alt={item.title}
                className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
              />

              {/* bottom shade for the caption */}
              <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-b tw-from-transparent tw-from-40% tw-to-black/[0.88]" />

              <div className="tw-absolute tw-left-[22px] tw-right-[22px] tw-bottom-[22px] tw-flex tw-flex-col tw-gap-1.5">
                <h3 className="tw-text-xl tw-font-semibold tw-text-white">
                  {item.title}
                </h3>
                <p className="tw-max-w-[220px] tw-text-sm tw-leading-[21px] tw-text-white/80">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
